export const SET_ACTIVE_CHARACTER = "SET_ACTIVE_CHARACTER";
export const ADD_CHARACTER = "ADD_CHARACTER";
export const SET_ANGLE = "SET_ANGLE";
